const DisclosureSection = () => (
  <section className="border-t border-border/50 bg-card/30 py-8">
    <div className="container">
      <div className="mx-auto max-w-2xl text-center">
        <h3 className="font-display text-base font-semibold text-foreground">
          Transparenzhinweis
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
          heilys.info ist eine unabhängige Informationsseite und nicht der offizielle heilys Shop. Bei einem Kauf über Partnerlinks erhalten wir eine Provision. Für dich entsteht dadurch kein Nachteil beim Preis. Alle Inhalte dieser Seite dienen der Orientierung und ersetzen keine medizinische Beratung.
        </p>
      </div>
    </div>
  </section>
);

export default DisclosureSection;
